module.exports = __webpack_public_path__ + "img/allow-notifications.49b6e892.png";